
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as logoutKq0aFwkSLIulrw_RRxoC4rYVO_459fHY1zjuozURDxZ_wMeta } from "/opt/node_app/app/src/pages/logout.vue?macro=true";
import { default as _reports_8VKaXCOhd1YacR8OZE1muOhWC3X52VGwztCsoBZuTEMeta } from "/opt/node_app/app/node_modules/.pnpm/@edco+apollo@0.1.1307_@unhead+vue@2.0.10_vue@3.5.16_typescript@5.7.2___db0@0.3.2_ioredis@5.6._xkd6n4k7txslgofk5escza2rdi/node_modules/@edco/apollo/src/pages/_reports.vue?macro=true";
import { default as _91_46_46_46slug_93xmEOPNarQqsHWGjurIfOXgtT6iH589bmtOR6Dl4OcyUMeta } from "/opt/node_app/app/node_modules/.pnpm/@edco+apollo@0.1.1307_@unhead+vue@2.0.10_vue@3.5.16_typescript@5.7.2___db0@0.3.2_ioredis@5.6._xkd6n4k7txslgofk5escza2rdi/node_modules/@edco/apollo/src/pages/[...slug].vue?macro=true";
import { default as _kitchen_45sinkFmF3VTdW1deE8s3wZkNap_7Ew5DPPqBLWYdZ4VPb_456kMeta } from "/opt/node_app/app/node_modules/.pnpm/@edco+apollo@0.1.1307_@unhead+vue@2.0.10_vue@3.5.16_typescript@5.7.2___db0@0.3.2_ioredis@5.6._xkd6n4k7txslgofk5escza2rdi/node_modules/@edco/apollo/src/pages/_kitchen-sink.vue?macro=true";
import { default as password_45resetmNUMM4INEyEzif6fgFPk_oi49sFJwff3H2RXJfA5WZAMeta } from "/opt/node_app/app/src/pages/password-reset.vue?macro=true";
import { default as ready3IkX2jUJx_45FcXYFUkmj2WNpROYo0iBn3HFIM8BOinxEMeta } from "/opt/node_app/app/node_modules/.pnpm/@edco+apollo@0.1.1307_@unhead+vue@2.0.10_vue@3.5.16_typescript@5.7.2___db0@0.3.2_ioredis@5.6._xkd6n4k7txslgofk5escza2rdi/node_modules/@edco/apollo/src/pages/_probes/nuxt/ready.vue?macro=true";
export default [
  {
    name: "logout",
    path: "/logout",
    component: () => import("/opt/node_app/app/src/pages/logout.vue")
  },
  {
    name: "_reports",
    path: "/_reports",
    meta: _reports_8VKaXCOhd1YacR8OZE1muOhWC3X52VGwztCsoBZuTEMeta || {},
    component: () => import("/opt/node_app/app/node_modules/.pnpm/@edco+apollo@0.1.1307_@unhead+vue@2.0.10_vue@3.5.16_typescript@5.7.2___db0@0.3.2_ioredis@5.6._xkd6n4k7txslgofk5escza2rdi/node_modules/@edco/apollo/src/pages/_reports.vue")
  },
  {
    name: "slug",
    path: "/:slug(.*)*",
    meta: {"middleware":"headless"},
    component: () => import("/opt/node_app/app/node_modules/.pnpm/@edco+apollo@0.1.1307_@unhead+vue@2.0.10_vue@3.5.16_typescript@5.7.2___db0@0.3.2_ioredis@5.6._xkd6n4k7txslgofk5escza2rdi/node_modules/@edco/apollo/src/pages/[...slug].vue")
  },
  {
    name: "_kitchen-sink",
    path: "/_kitchen-sink",
    meta: _kitchen_45sinkFmF3VTdW1deE8s3wZkNap_7Ew5DPPqBLWYdZ4VPb_456kMeta || {},
    component: () => import("/opt/node_app/app/node_modules/.pnpm/@edco+apollo@0.1.1307_@unhead+vue@2.0.10_vue@3.5.16_typescript@5.7.2___db0@0.3.2_ioredis@5.6._xkd6n4k7txslgofk5escza2rdi/node_modules/@edco/apollo/src/pages/_kitchen-sink.vue")
  },
  {
    name: "password-reset",
    path: "/password-reset",
    component: () => import("/opt/node_app/app/src/pages/password-reset.vue")
  },
  {
    name: "_probes-nuxt-ready",
    path: "/_probes/nuxt/ready",
    meta: ready3IkX2jUJx_45FcXYFUkmj2WNpROYo0iBn3HFIM8BOinxEMeta || {},
    component: () => import("/opt/node_app/app/node_modules/.pnpm/@edco+apollo@0.1.1307_@unhead+vue@2.0.10_vue@3.5.16_typescript@5.7.2___db0@0.3.2_ioredis@5.6._xkd6n4k7txslgofk5escza2rdi/node_modules/@edco/apollo/src/pages/_probes/nuxt/ready.vue")
  }
]